var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Autocomplete, TextField, } from "@mui/material";
import React from "react";
export function CustomAutocomplete(props) {
    var textFieldProps = props.textFieldProps, renderInput = props.renderInput, rest = __rest(props, ["textFieldProps", "renderInput"]);
    return (_jsx(Autocomplete, __assign({}, rest, { renderInput: renderInput || (function (params) { return (_jsx(TextField, __assign({}, params, textFieldProps, { inputProps: __assign(__assign({}, params.inputProps), { autoComplete: "new-password" }) }))); }) })));
}
